import { AuthHandler, unwrapSingleton } from '@/core';
import { clearData } from './store';
import { router } from '../router';
import { trpcClient } from ".";
import type { Router } from "vue-router";



export const auth = new AuthHandler({
    onSignOut: () => {
        clearData();
    },
    apiClient: trpcClient,
    router: router
});

/**
 * Redirects to the login page with the current route set
 * as next path. This is useful when the user navigates
 * to a page that requires authentication without
 * being logged in.
 * @param router 
 */
export function redirectToLoginWithNextPath(router: Router) {
    const nextPath = router.currentRoute.value?.path;
    const currentQuery = router.currentRoute.value?.query || {};

    const queryParams = new URLSearchParams();
    for (const [key, rawValue] of Object.entries(currentQuery)) {
        const value = unwrapSingleton(rawValue)
        if (value !== null) {
            queryParams.set(key, value);
        }
    }

    const fullNextPath = queryParams.size > 0 ? `${nextPath}?${queryParams.toString()}` : nextPath;
    // vue-router does not seem to handle URL encode/decode for query params
    const encodedNextPath = encodeURIComponent(fullNextPath);
    router.push({ name: 'login', query: { next: encodedNextPath } });
}